import React from 'react';
import { Button, Table } from 'react-bootstrap';
import { Link } from 'react-router';
import axios from './../../../constants/axios';
import moment from 'moment';
import classname from 'classnames';
import DatePicker from 'react-datepicker';

class FixedAssetHome extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         fixedAssets: [],
         startDate: null,
         endDate: null,
      };
   }


   componentDidMount() {
      axios.get('fixedAssets')
         .then((res) => {
            this.setState({
               fixedAssets: res.data.results,
               startDate: moment(res.data.startDate),
               endDate: moment(res.data.endDate),
            });
         });
   }

   handleStartDateChange = (date) => {
      this.setState({
         startDate: date
      });
   };

   handleEndDateChange = (date) => {
      this.setState({
         endDate: date
      });
   };

   getInvoicesDateBetween = () => {
      const { startDate, endDate } = this.state;
      if (startDate && endDate) {
         axios.get(`fixedAssets?startDate=${startDate.format('YYYY-MM-DD')}&endDate=${endDate.format('YYYY-MM-DD')}`)
            .then((res) => {
               this.setState({
                  fixedAssets: res.data.results,
                  startDate: moment(res.data.startDate),
                  endDate: moment(res.data.endDate),
               });
            });
      }
   };

   render() {
      const { fixedAssets } = this.state;
      return (
         <div className="FixedAssetHome" >
            <h1 >Fixed Asset Home</h1 >
            <div >
               <DatePicker
                  dateFormat="DD-MM-YYYY"
                  selected={this.state.startDate}
                  placeholderText="Select Start Date"
                  onChange={this.handleStartDateChange} />
               <DatePicker
                  dateFormat="DD-MM-YYYY"
                  selected={this.state.endDate}
                  placeholderText="Select End Date"
                  onChange={this.handleEndDateChange} />
               <Button onClick={() => this.getInvoicesDateBetween()} >Get Invoices</Button >
            </div >
            <Table >
               <thead >
               <tr >
                  <th >#inv Id</th >
                  <th >Contact Name</th >
                  <th >Billed</th >
                  <th >Paid Amount</th >
                  <th >Due</th >
                  <th >Inv Created</th >
                  <th >##</th >
               </tr >
               </thead >
               <tbody >
               {fixedAssets.map((fixedAsset) => (
                  <tr key={fixedAsset.id} className={classname({ 'due_invoice': fixedAsset.due !== 0 })} >
                     <td >{fixedAsset.id}</td >
                     <td >{fixedAsset.contact_name}</td >
                     <td >{fixedAsset.total_amount}</td >
                     <td >{fixedAsset.paid_amount}</td >
                     <td >{fixedAsset.due}</td >
                     <td >{fixedAsset.created_at}</td >
                     <td >
                        <Link to={`/fixedAsset/fixedAssetInvoiceDetail/${fixedAsset.id}`} >Details</Link >
                        {fixedAsset.due !== 0 &&
                        <Link to={`/fixedAsset/fixedAssetPayBill/${fixedAsset.id}`} >Pay</Link >
                        }
                     </td >
                  </tr >
               ))}
               </tbody >
            </Table >
         </div >
      );
   }
}

FixedAssetHome.propTypes = {};


export default FixedAssetHome;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/FixedAsset/FixedAssetHome.js
 **/